import React, { useEffect, useState } from "react";
import "./styles/cetificate.css";
import Certificateservice from "../../service/Certificateservice";

const Certificate = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await Certificateservice.getAllInfo();
      const newData = response.docs.map((doc) => doc.data());
      setData(newData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="certificate-container">
      <h2 className="certificate-title">Certificates</h2>
      <div className="certificate-list">
        {data.map((cert, index) => (
          <div key={index} className="certificate-item">
            <div className="certificate-image">
              <img src={cert.image} alt={cert.name} />
            </div>
            <div className="certificate-name">{cert.name}</div>
            <div className="certificate-issuer">{cert.issuer}</div>
            <div className="certificate-year">{cert.year}</div>
            <div className="certificate-link">
              <a href={cert.link} target="_blank" rel="noopener noreferrer">
                Certificate Link
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificate;
